import add from 'assets/icons/add_icon.svg';
import edit from 'assets/icons/edit_icon.svg';
import deleteIcon from 'assets/icons/delete_icon.svg';
import info from 'assets/icons/info_icon.svg';
import approve from 'assets/icons/approve_icon.svg';
import unapprove from 'assets/icons/unapprove_icon.svg';
import pdf from 'assets/icons/pdf_icon.svg';
import graph from 'assets/icons/graph_icon.svg';
import back from 'assets/icons/back_icon.svg';
import close from 'assets/icons/close_icon.svg';
import image from 'assets/icons/image_icon.svg';
import copy from 'assets/icons/copy_icon.svg';
import diagnosesNok from 'assets/icons/diagnonses_nok_icon.svg';
import save from 'assets/icons/save_icon.svg';
import calendar from 'assets/icons/calendar_icon.svg';

const APP_ICONS = {
  add,
  edit,
  delete: deleteIcon,
  info,
  approve,
  unapprove,
  pdf,
  graph,
  back,
  close,
  image,
  copy,
  diagnosesNok,
  save,
  calendar
};

export default APP_ICONS;
